module.exports = "https://static.wmbcdn.com/uniweb/images/4b233a7838672ad0a6f6db0c3c094108.svg";